import { render } from "./Social-links.vue?vue&type=template&id=4eca2a84&scoped=true"
import script from "./Social-links.vue?vue&type=script&lang=js"
export * from "./Social-links.vue?vue&type=script&lang=js"

import "./Social-links.vue?vue&type=style&index=0&id=4eca2a84&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4eca2a84"]])

export default __exports__